import { Button } from "@mui/material";
import React from "react";
import { ChamberMemberProPagePermissionsEnum } from "../../../graphql/types";
import { commonStyles } from "../../common/commonStyles";
import { canCreateCmpMemberApplication } from "./memberApplicationPermissions";

export type MemberRestartApplicationActionProps = {
  actionLoading: boolean;
  backendCanStartNewApplication: boolean;
  blockedReason?: string;
  onStart: () => void;
  permissions?: ReadonlyArray<ChamberMemberProPagePermissionsEnum> | null;
};

const MemberRestartApplicationAction = ({
  actionLoading,
  backendCanStartNewApplication,
  blockedReason,
  onStart,
  permissions,
}: MemberRestartApplicationActionProps) => {
  if (!canCreateCmpMemberApplication(permissions)) {
    return null;
  }

  return (
    <div>
      <Button
        variant="contained"
        disabled={!backendCanStartNewApplication || actionLoading}
        onClick={onStart}
        sx={{
          backgroundColor: commonStyles.cpaGold,
          color: "white",
          fontWeight: 800,
          minWidth: 330,
          "&:hover": { backgroundColor: "#9b701d" },
        }}
      >
        Submit New Company Membership Application
      </Button>
      {!backendCanStartNewApplication && blockedReason && (
        <p className="mt-2 max-w-2xl text-sm leading-6 text-black" role="status">
          {blockedReason}
        </p>
      )}
    </div>
  );
};

export default MemberRestartApplicationAction;
